export const changeS3UrlToCdn = (url) => {
    if (!url) return url;
    
    const cdnUrl = 'cdn.beedoo.io';
    const s3Url = 's3.amazonaws.com/beedoo-user-us';
    const s3Url2 = 'beedoo-user-us.s3.amazonaws.com';
    return url.replace(s3Url, cdnUrl).replace(s3Url2, cdnUrl);
}